import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { errorMessage, fetchOfficialDocuments } from './api';
import PageBack from './PageBack';
import { documentPrice, OfficialDocumentOrderRow } from './OfficialDocuments';

export default function DocumentsArchive() {
  const documents = useQuery({
    queryKey: ['official-documents'],
    queryFn: fetchOfficialDocuments,
    staleTime: 30_000,
  });
  const rows = documents.data ?? [];
  const totalSpent = rows.reduce((sum, order) => sum + order.priceCents, 0);
  const ready = rows.filter((order) => order.ready).length;
  const pending = rows.length - ready;

  return <div className="documents-archive-page">
    <PageBack fallback="/altro" label="Torna ad Altro"/>
    <header className="page-header documents-archive-head"><div><p className="eyebrow">Archivio acquisti</p><h1>I miei documenti</h1><p className="page-description">Visure e bilanci pagati, raccolti in un solo posto. Le copie archiviate da Osservio restano scaricabili.</p></div></header>

    {documents.isPending && <div className="documents-archive-loading" role="status"><span className="sr-only">Caricamento documenti acquistati</span><i/><i/><i/></div>}
    {documents.isError && <div className="notice notice-error"><p>{errorMessage(documents.error)}</p><button type="button" className="btn-secondary" onClick={() => documents.refetch()}>Riprova</button></div>}

    {documents.isSuccess && rows.length === 0 && <section className="empty documents-archive-empty"><p className="empty-kicker">Nessun acquisto</p><h2>Qui ritroverai ogni documento pagato</h2><p>Visure e bilanci si ordinano dal dettaglio di un’attività dopo aver confermato la società corretta.</p><Link className="btn-primary" to="/competitor/locale?new=1">Apri la ricerca locale</Link></section>}

    {rows.length > 0 && <>
      <section className="documents-spend-summary" aria-label="Riepilogo spesa documenti">
        <div><span>Totale speso</span><strong>{documentPrice(totalSpent)}</strong></div>
        <dl><div><dt>Acquisti</dt><dd>{rows.length}</dd></div><div><dt>Pronti</dt><dd>{ready}</dd></div>{pending > 0 && <div><dt>In erogazione</dt><dd>{pending}</dd></div>}</dl>
      </section>
      <section className="documents-archive-list" aria-labelledby="documents-list-title">
        <header><div><p className="eyebrow">Dal più recente</p><h2 id="documents-list-title">Tutti gli acquisti</h2></div><span>{rows.length}</span></header>
        <div>{rows.map((order) => <OfficialDocumentOrderRow key={order.orderId} initialOrder={order} showCompany/>)}</div>
      </section>
      <p className="documents-archive-note"><strong>Nessun riordino necessario.</strong> I documenti in erogazione vengono controllati dal server ogni 10 minuti e compariranno come pronti automaticamente.</p>
    </>}
  </div>;
}
